import { render } from "./ClawView.vue?vue&type=template&id=b62d29a2&scoped=true"
import script from "./ClawView.vue?vue&type=script&lang=js"
export * from "./ClawView.vue?vue&type=script&lang=js"

import "./ClawView.vue?vue&type=style&index=0&id=b62d29a2&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_omroepwest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62d29a2"]])

export default __exports__